<template>
  <Tooltip>
    <template #element>
      <span>
        Startdatum auswählen
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Ab wann kannst du in die Anwendung der Methode gehen? Wähle das heutige Datum aus – oder einen Zeitpunkt, der in der Zukunft liegt
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
